import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsFacet, ConvertedComponentData, FsCatalog } from '../types'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CmsProductListConverter extends CmsConverterService<CmsProductListData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      productIds: formData.st_product_ids ?? defaultFSCatalog,
      categoryId: formData?.st_category_id ?? defaultFSCatalog,
      facets: formData.pt_tags ?? []
    }
  }
}

export const CMS_PRODUCT_LIST_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, CmsProductListData>>('CmsProductListConverter')

export interface CmsProductListData extends ConvertedComponentData {
  productIds: FsCatalog<string>;
  categoryId: FsCatalog<string>;
  facets: CmsFacet[];
}
